Property_service_oncloud = {
	p_call_list: []
	,
	init : function(){
	}
	,
	get_data : function( pm_url = '', pm_config = {} )
	{
		// Get service path to retrieve property service data.
		var request_url = oc__oncloud_settings.url + pm_url;
		
		// Disallow repeated calls. One call per service.
		let allow_call = ( Property_service_oncloud.p_call_list.indexOf(request_url) < 0 );
		if( !allow_call )
		{
			//console.log('ALREADY LOADING DATA FOR: ',request_url);
			return(false);
		}
		
		// Assemble options for data call.
		var config = pm_config;
		
		// Add the call to the call list. 
		Property_service_oncloud.p_call_list.push(request_url);
		
		jQuery.ajax({
			type: "POST",
			url: request_url,
			contentType: "text/plain; charset=utf-8",
			dataType: "json",
			data: JSON.stringify( config ),
			success: function( data, status, jqXHR ){
				// Emit event. After OnCloud Property Service data retrieval.
				var response = {};
				response.success = true;
				response.url = request_url;
				response.config = config;
				response.data = data;
				jQuery(document).trigger('oc_property_service_oc_data_retrieval',response);
			}
		});
	}
	,
	get_aa_data : function( pm_action = '', pm_config = {} )
	{
		// Data URL - AJAX Admin URL stored in page config object.
		var data_url = oc__system_settings.ajax_url;
		
		// Disallow repeated calls. One call per service.
		let allow_call = ( Property_service_oncloud.p_call_list.indexOf(pm_action) < 0 );
		if( !allow_call )
		{
			console.log('ALREADY LOADING DATA FOR: ',pm_action);
			return(false);
		}
		
		// Assemble options for data call.
		var config = pm_config;
		
		// Add the call to the call list. 
		Property_service_oncloud.p_call_list.push(pm_action);
		
		// Admin AJAX call.
		jQuery.ajax({
			type: 'post',
			dataType: 'json',
			url: data_url,
			data: config,
			success: function(result){
				console.log('AA DATA RESULT: ', result);
				console.log('SUCCESS: ', result.success);
				
				// Check our data request was successful.
				if( result.success )
				{
					// Get the Property List.
					//console.log('PROPERTIES: ', result.data.property_list.properties);
					//var property_list = result.data.property_list.properties;
					
					// Emit event. After OnCloud Property Service data retrieval.
					var response = {};
					response.success = true;
					response.url = data_url;
					response.config = config;
					response.data = result.data;
					jQuery(document).trigger('oc_property_service_oc_data_retrieval_aa',response);
				}	
			}
		});
	}
}

jQuery(document).ready(function(jQuery){
	Property_service_oncloud.init();
});